import { schema } from 'normalizr';

export const unitSchema = new schema.Entity(
	'units'
);

export default unitSchema;
